<template>
  <div class="bg-white rounded-lg p-2">
    <div class="flex justify-center">
      <LoadingSpinner
        class="h-10 w-10 text-yellow-500/80 my-8"
        v-if="loading"
      />
      <apexchart
        class=""
        type="bar"
        width="350"
        :options="options"
        :series="series"
        v-else-if="this.series[0].data.length"
      />
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>
<script>
import { horekaSaleReport } from "../API/API";
import LoadingSpinner from "./General/LoadingSpinner.vue";

export default {
  name: "SaleTonajChart",
  components: { LoadingSpinner },
  props: ["year", "month", "day"],
  data() {
    return {
      loading: true,
      series: [],
      options: {
        chart: {
          height: 550,
          type: "area",
        },
        colors: ["#BE123C"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return this.$helper.numberShortener(val);
            },
          },
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [];
      //this.options.labels = [];
      this.loading = true;
      horekaSaleReport("day", "qty", this.year, this.month, this.day).then(
        (resp) => {
          this.options = { ...this.options, xaxis: { categories: resp.data.result.xaxis, },};
          resp.data.result.yaxis.forEach((item) => {
            this.series.push({
              name: item.name,
              data: item.dData,
            });
          });
          this.loading = false;
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
    year() {
      this.getReports();
    },
  },
};
</script>
